import { render, staticRenderFns } from "./Rolling7Level1.vue?vue&type=template&id=5142637d&scoped=true"
import script from "./Rolling7Level1.vue?vue&type=script&lang=js"
export * from "./Rolling7Level1.vue?vue&type=script&lang=js"
import style0 from "./Rolling7Level1.vue?vue&type=style&index=0&id=5142637d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5142637d",
  null
  
)

export default component.exports